export function getUserTenantId(user) {
  return (
    user?.tenantID ||
    user?.tenantId ||
    user?.tenant?.id ||
    user?.tenantUser?.tenantId ||
    user?.tenantUser?.tenantID ||
    user?.tenantUsers?.[0]?.tenantId ||
    user?.tenantUsers?.[0]?.tenantID ||
    user?.tenants?.[0]?.id ||
    null
  );
}